import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

interface TimeSlotProps {
  isAllowed: boolean;
}

export const WeekContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 1rem;

    color: ${Colors.primary[100]};
`;

export const WeekdayContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    width: 125px;
    background-color: ${Colors.commons.white};
    box-shadow: 0.25rem 0.25rem 0.25rem ${Colors.commons.gray};
    
    padding: 1rem 0.5rem; 
    
    border-radius: 1rem;
`;

export const DayName = styled.h4`
    font-weight: bold;
    margin: 0;
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
`;

export const SlotsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;

    width: 100%;
`;

export const TimeSlot = styled.button<TimeSlotProps>`
    display: flex;
    justify-content: center;
    align-items: center;

    border: 2px solid ${({ isAllowed }) => isAllowed ?  Colors.green[100] :  Colors.secondary[100]};
    border-radius: 0.5rem;

    height: 30px;
    width: 100%;
    padding: 0.5rem; /* opcional */

    background-color: ${({ isAllowed }) =>
    isAllowed ? Colors.green[100]+"4D" : Colors.secondary[100]+"4D"};

    /* opacity: ${({ isAllowed }) =>
    isAllowed ? "50%" : "100%"}; */

    /* color: ${Colors.primary[100]}; */
    font-size: 1.25rem;

    /* line-height: 1rem; */
    cursor: pointer;
`;
